var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)+":")]),_c('span',{staticClass:"title-info",domProps:{"innerHTML":_vm._s(_vm.info)}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }